import React from 'react';
import PropTypes from 'prop-types';
import { styled } from '@uhg-abyss/web/tools/styled';

const CardBodyStyle = styled('div', {
  padding: 15,
  borderTopWidth: 1,
  borderStyle: 'solid',
  borderColor: '$gray2',
});

export const CardBody = ({ children, ...props }) => {
  if (!children) {
    return null;
  }

  return <CardBodyStyle {...props}>{children}</CardBodyStyle>;
};

CardBody.propTypes = {
  children: PropTypes.node,
};

CardBody.defaultProps = {
  children: null,
};
